import type { ModuleKey } from './moduleCatalog';

/**
 * Which product module a page belongs to, so a direct URL to a module that is
 * off sends the user home instead of opening an empty page full of 403s.
 * Checked once in the app shell (web Layout, mobile Layout). Longest prefix
 * wins; pages of core modules (tasks, projects) and Settings are not listed.
 */
const ROUTES: ReadonlyArray<readonly [string, ModuleKey]> = [
  ['/dashboard', 'dashboard'],
  ['/daily-summary', 'dailySummary'],
  ['/weekly-summary', 'weeklySummary'],
  ['/chat', 'aiAssistant'],
  ['/voice', 'aiAssistant'],
  ['/mcp', 'mcp'],
  ['/meet', 'videoMeetings'],
  ['/team-chat', 'teamChat'],
  ['/reminders', 'reminders'],
  ['/concedii', 'leave'],
  ['/calendar', 'calendar'],
  ['/reports/tasks', 'taskReports'],
  ['/meetings', 'meetings'],
  ['/actors', 'actors'],
  ['/leads', 'leads'],
  ['/clients', 'clients'],
  ['/suppliers', 'suppliers'],
  ['/subscriptions', 'subscriptions'],
  ['/financials', 'financials'],
  ['/financials/issued', 'invoices'],
  ['/invoices', 'invoices'],
  ['/smartbill', 'invoices'],
  ['/financials/spv', 'spv'],
  ['/financials/bank-statements', 'bankStatements'],
  ['/financials/reconciliation', 'bankStatements'],
  ['/financials/cashflow', 'cashflow'],
  ['/financials/reports', 'monthlyReports'],
];

export function moduleForPath(pathname: string): ModuleKey | null {
  let best: readonly [string, ModuleKey] | null = null;
  for (const route of ROUTES) {
    const [prefix] = route;
    const matches = pathname === prefix || pathname.startsWith(`${prefix}/`);
    if (matches && (!best || prefix.length > best[0].length)) best = route;
  }
  return best ? best[1] : null;
}
